module.exports = __webpack_public_path__ + "static/media/TRU.35d54e63.svg";